import DepartmentPlanCard from "./DepartmentPlanCard";
import { useDepartmentsPlan, DepartmentPlanKey } from "./useDepartmentsPlan";
import { useDepartmentsForecastPlans } from "./useDepartmentsForecastPlans";
import { useWorkspace } from "@/features/Workspace/lib/useWorkspace";
import { useAuth } from "@/features/Auth/lib/useAuth";
import { canSeeCommercialOverview } from '@/features/Auth/lib/salesAccess';
import { MainTypesPlans } from "../../../model/dashboard.types";
import { useNavigate } from 'react-router-dom';

function getDepartmentName(departmentId: number, departments: { id: number; name: string }[]): string {
  const dep = departments.find((d) => d.id === departmentId);
  return dep?.name ?? `Отдел ${departmentId}`;
}

function DepartmentsPlan() {
  const { results, loading, error, departmentIds, dateStart, dateEnd } = useDepartmentsPlan();
  const forecasts = useDepartmentsForecastPlans();
  const { departments } = useWorkspace();
  const { user } = useAuth();
  const navigate = useNavigate();

  const isDirector = canSeeCommercialOverview(user);
  const showAllCards = isDirector;

  const openAnalytics = (departmentId: number) => {
    if (!dateStart || !dateEnd) return;
    const query = new URLSearchParams({
      scope: 'department',
      departmentId: String(departmentId),
      dateStart,
      dateEnd,
    });
    navigate(`/SalePlan/analytics?${query.toString()}`);
  };

  return (
    <>
      {departmentIds.map((departmentId) => {
        const oppKey: DepartmentPlanKey = `${departmentId}_${MainTypesPlans.opportunitie}`;
        const profitKey: DepartmentPlanKey = `${departmentId}_${MainTypesPlans.profit}`;
        const opportunity = results[oppKey];
        const profit = results[profitKey];
        const forecast = forecasts[departmentId];
        const deptName = getDepartmentName(departmentId, departments);

        const showCard =
          showAllCards ||
          loading ||
          (opportunity != null && (opportunity.target ?? 0) > 0) ||
          (profit != null && (profit.target ?? 0) > 0);

        if (!showCard) return null;

        return (
          <DepartmentPlanCard
            key={departmentId}
            title={deptName}
            col={15}
            row={10}
            loading={loading}
            error={error}
            opportunity={opportunity ?? null}
            profit={profit ?? null}
            opportunityForecast={forecast?.opportunity ?? null}
            profitForecast={forecast?.profit ?? null}
            onClick={() => openAnalytics(departmentId)}
          />
        );
      })}
    </>
  );
}

export default DepartmentsPlan;
